import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress
} from '@mui/material';
import { red } from '@mui/material/colors';

interface RejectCancelDialogProps {
  isRefund: boolean;
  order: any;
  amount?: number;
  onReject: (order: any, reason: string) => void;
  onRefund: (order: any, amount: number, reason: string) => void;
  rejecting?: boolean;
  refunding?: boolean;
}

const RejectCancelDialog = (props: RejectCancelDialogProps) => {
  const [open, setOpen] = React.useState(false);
  const [reason, setReason] = React.useState<string>('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setReason(''); // Clear reason when closing
  };

  const onChangeReason = (evt: any) => {
    setReason(evt.target.value);
  };

  const onRefundReject = () => {
    if (props.isRefund) {
      props.onRefund(props.order, props.amount || 0, reason);
    } else {
      props.onReject(props.order, reason);
    }
    // Close modal immediately after action is triggered
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleClickOpen}
        sx={{
          color: red[500],
          backgroundColor: 'white',
          border: `1px solid ${red[500]}`,
          boxShadow: 'none',
          height: 60,
          '&:hover': {
            backgroundColor: red[700],
            color: 'white'
          }
        }}
      >
        {props.isRefund ? 'Refund' : 'Reject'}
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {props.isRefund ? 'Refund Reason' : 'Reject Reason'}
        </DialogTitle>
        <DialogContent>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Select Reason</InputLabel>
            <Select value={reason} onChange={onChangeReason} fullWidth>
              <MenuItem value="CUSTOMER_CANCELLED_REQ">
                Customer Cancelled Order
              </MenuItem>
              <MenuItem value="CUSTOMER_NOT_HAPPY">Customer Not Happy</MenuItem>
              <MenuItem value="CUSTOMER_WRONG_ITEMS">
                Customer Wrong Items
              </MenuItem>
              <MenuItem value="MANNA_TECHNICAL">Mechanical Issue</MenuItem>
              <MenuItem value="MANNA_WEATHER">Weather</MenuItem>
              <MenuItem value="STORE_ISSUE">Store Issue</MenuItem>
              <MenuItem value="OTHER">Other</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onRefundReject} color="primary" disabled={!reason}>
            {(props.refunding || props.rejecting) && (
              <CircularProgress size={12} />
            )}
            {!props.refunding &&
              !props.rejecting &&
              (props.isRefund ? 'Refund' : 'Reject')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RejectCancelDialog;
